import React from 'react';

export const PlayIcon = ({height = 64, width=64, fill = "#FFFFFF"}) => {

    return (
    <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" width={width}
         height={height} fill={fill} viewBox="0 0 24 24">
        <path fillRule="evenodd" d="M8.6 5.2A1 1 0 0 0 7 6v12a1 1 0 0 0 1.6.8l8-6a1 1 0 0 0 0-1.6l-8-6Z"
              clipRule="evenodd"/>
    </svg>

)
};